import LoadingButton from '@mui/lab/LoadingButton'

const Button = LoadingButton
export default Button
